import { FC, PropsWithChildren } from "react";
import { useExecuteExternalSignIn } from "./execute-external-sign-in";

export const CustomConfigurableActionsAccessor: FC<PropsWithChildren<{}>> = ({ children }) => {
    useExecuteExternalSignIn();

    return (
        <>{children}</>
    );
};